/**
 * @license
 * Copyright Akveo. All Rights Reserved.
 * Licensed under the MIT License. See License.txt in the project root for license information.
 */
export function bootstrapServiceFactory(
  bootstrapService: BootstrapService
): Function {
  return () => bootstrapService.load();
}
import { BrowserModule } from "@angular/platform-browser";
import { BrowserAnimationsModule } from "@angular/platform-browser/animations";
import { APP_INITIALIZER, NgModule } from "@angular/core";
import { HttpClientModule, HTTP_INTERCEPTORS } from "@angular/common/http";
import { CoreModule } from "./@core/core.module";
import { ThemeModule } from "./@theme/theme.module";
import { AppComponent } from "./app.component";
import { AppRoutingModule } from "./app-routing.module";
import {
  NbChatModule,
  NbDatepickerModule,
  NbDialogModule,
  NbMenuModule,
  NbSidebarModule,
  NbToastrModule,
  NbWindowModule,
} from '@nebular/theme';
import { AuthModule } from './auth/auth.module';
import { CommonModule } from '@angular/common';  
import { UrlInterceptor } from './@core/interceptors/url.interceptor';
import { Globals } from './gloabls';
import { BootstrapService } from './@shared/util/bootstrap.service';
import { ChartsComponent } from './@shared/components/charts/charts.component';
import { TokenInterceptor } from './@core/interceptors/token.interceptor';

import { StatisticsNewComponent } from './@shared/components/create-modal/statistics-new/statistics-new.component';
import { NBIMPORTS } from "./app.nb-imports";
import { MATERIALS } from "./@shared/app.material";
import { SHARD3RDIMPORTS } from "./shared-3rd-party";
import { HTTPErrorsInterceptor } from "./@core/interceptors/httperrors.interceptor";

@NgModule({
  declarations: [AppComponent, StatisticsNewComponent],
  imports: [
    CommonModule,
    BrowserModule,
    BrowserAnimationsModule,
    HttpClientModule,
    AppRoutingModule,
    AuthModule,
    NBIMPORTS,
    MATERIALS,
    SHARD3RDIMPORTS,
    NbSidebarModule.forRoot(),
    NbMenuModule.forRoot(),
    NbDatepickerModule.forRoot(),
    NbDialogModule.forRoot(),
    NbWindowModule.forRoot(),
    NbToastrModule.forRoot(),
    NbChatModule.forRoot({
      messageGoogleMapKey: "AIzaSyA_wNuCzia92MAmdLRzmqitRGvCF7wCZPY",
    }),
    CoreModule.forRoot(),
    ThemeModule.forRoot(),
  ],
  bootstrap: [AppComponent],
  providers: [
    {
      provide: APP_INITIALIZER,
      useFactory: bootstrapServiceFactory,
      deps: [BootstrapService],
      multi: true,
    },
    {
      provide: HTTP_INTERCEPTORS,
      useClass: HTTPErrorsInterceptor,
      multi: true,
    },
    {
      provide: HTTP_INTERCEPTORS,
      useClass: UrlInterceptor,
      multi: true,
    },
    {
      provide: HTTP_INTERCEPTORS,
      useClass: TokenInterceptor,
      multi: true,
    },
    Globals,
    BootstrapService,
  ],
})
export class AppModule {}
